import { createStore, applyMiddleware } from 'redux';
import { enableBatching } from 'redux-batched-actions';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import promise from 'redux-promise';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import rootSaga from './sagas';

export default (
  createRootReducer,
  history = null,
  thunkExtraArgument = null,
) => {
  const reducer = enableBatching(createRootReducer(history));
  const thunkWithExtraArgument =
    thunkExtraArgument !== null
      ? thunk.withExtraArgument(thunkExtraArgument)
      : thunk;
  const sagaMiddleware = createSagaMiddleware();
  let enhancer;
  if (history) {
    enhancer = applyMiddleware(
      thunkWithExtraArgument,
      promise,
      sagaMiddleware,
      routerMiddleware(history),
    );
  } else {
    enhancer = applyMiddleware(thunkWithExtraArgument, promise, sagaMiddleware);
  }

  const store = createStore(
    reducer,
    {},
    composeWithDevTools({
      trace: true,
      traceLimit: 25,
    })(enhancer),
  );

  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('reducers', () => {
      const nextRootReducer = require('reducers/index');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};
